import request from '@/plugin/axios'

export function ListAllSubjects (data) {
  return request({
    url: '/subject/index',
    method: 'get',
    params: data
  })
}

export function ViewSubject (data) {
  return request({
    url: '/subject/view',
    method: 'get',
    params: data
  })
}

export function GetAssistItems (id) {
  return request({
    url: '/subject/assist-items?id=' + id,
    method: 'get'
  })
}

export function CreateSubject (data) {
  return request({
    url: '/subject/create',
    method: 'post',
    data
  })
}

export function EditSubject (id, data) {
  return request({
    url: '/subject/update?id=' + id,
    method: 'post',
    data
  })
}

export function ReviewSubject (id) {
  return request({
    url: '/subject/review?id=' + id,
    method: 'post'
  })
}

export function ListDomainStates (id, data = {}) {
  return request({
    url: '/domain-state/index?usubjid=' + id,
    method: 'get',
    params: data
  })
}

export function ViewDomain (id) {
  return request({
    url: '/domain-state/domain?id=' + id,
    method: 'get'
  })
}

export function ListVariables (id) {
  return request({
    url: '/domain-state/list-vars?id=' + id,
    method: 'get'
  })
}

export function CreateDomain (id, data) {
  return request({
    url: '/domain-state/create-domain?id=' + id,
    method: 'post',
    data
  })
}

export function MarkDomainStatus (id, data) {
  return request({
    url: '/domain-state/mark-domain-status?id=' + id,
    method: 'post',
    data
  })
}

export function EditVariable (data) {
  return request({
    url: '/domain-state/edit-variable',
    method: 'post',
    data
  })
}

export function EditForm (id, data) {
  return request({
    url: '/domain-state/edit-form?id=' + id,
    method: 'post',
    data
  })
}

export function EditOneOfMuitRecord (data) {
  return request({
    url: '/domain-state/edit-record',
    method: 'post',
    data
  })
}

export function DeleteOneOfMuitRecord (data) {
  return request({
    url: '/domain-state/delete-record',
    method: 'post',
    data
  })
}

export function DeleteRepeated (data) {
  return request({
    url: '/domain-state/del-repeats',
    method: 'post',
    data
  })
}
